import { render } from "./FlaggedPollsPage.vue?vue&type=template&id=6a1bc0d1"
import script from "./FlaggedPollsPage.vue?vue&type=script&lang=js"
export * from "./FlaggedPollsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__